import type { RecordValue } from "./types.ts";

/** The server derives this value from exact scores and the effective denominator. */
export function sourceContribution(source: RecordValue): number | null {
  const value = source.contributionScore;
  if (source.missing || value == null || String(value).trim() === "" ||
      typeof value !== "string" && typeof value !== "number") return null;
  const contribution = Number(value);
  return Number.isFinite(contribution) && contribution >= 0 && contribution <= 100 ? contribution : null;
}
